<h2
  mat-dialog-title
  mat-dialog-draggable-title
  style="margin-bottom: 0px !important"
>
  <span>{{'down_sign_transaction.result_title' | translate}}</span>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-dialog-content>
  <mat-divider></mat-divider>
  <div class="mt-2" style="padding: 0px 10px">
    <p>{{'down_sign_transaction.handle_success' | translate}}: {{data.doneTransaction}}</p>
    <p>{{'down_sign_transaction.handle_failed' | translate}}: {{data.errorTransaction}}</p>
  </div>
  <div>
    <span class="font-weight-bold">
      {{'down_sign_transaction.result_note' | translate}}
    </span>
    <div class="font-italic ml-2">
      {{'down_sign_transaction.result_description_success' | translate}}
    </div>
    <div class="font-italic ml-2">{{'down_sign_transaction.result_description_failed' | translate}}</div>
  </div>
</mat-dialog-content>
<div mat-dialog-actions class="justify-content-center mt-2">
  <!--build icon, set default cancel-->
  <button mat-raised-button color="primary" class="ml-2" (click)="close()">
    <mat-icon class="mr-2">cancel</mat-icon>{{ "button.close" | translate }}
  </button>
</div>
